module.exports = __webpack_public_path__ + "static/img/n-contract-function.744f1eb3.png";